import { AxiosResponse } from "axios";
import * as API from "./api";
import { LoginFormType } from "../pages/login/types";
import {
  EmailType,
  ILoginResponse,
  LoginEmailTypeResponse,
  RestoreEmailResponse,
  RestorePasswordRequestType,
} from "../sagas/types/login";
import { CountryCodeType } from "reducers/types/session";

export const getLogin = (
  params: LoginFormType,
  countryCode: CountryCodeType
): Promise<AxiosResponse<ILoginResponse>> => {
  return API.post("/ms-admin-rest/api/v1.0/login", params, {
    headers: { "country-code": countryCode, optionalToken: true },
  });
};

export const setAuthToken = (token: string) => {
  API.setAuthToken(token);
};
export const getLoginRestore = (
  params: RestorePasswordRequestType
): Promise<AxiosResponse<RestoreEmailResponse>> =>
  API.put("/ms-admin-rest/api/v1.0/admin/change-password", params, {
    headers: { optionalToken: true },
  });
export const sendRestoreEmail = (
  params: EmailType
): Promise<AxiosResponse<LoginEmailTypeResponse>> =>
  API.post("ms-admin-rest/api/v1.0/admin/request-change-password", params, {
    headers: { optionalToken: true },
  });
